import { render, staticRenderFns } from "./ExternalConsultantsEditor.vue?vue&type=template&id=052ffbe6&scoped=true&"
import script from "./ExternalConsultantsEditor.vue?vue&type=script&lang=ts&"
export * from "./ExternalConsultantsEditor.vue?vue&type=script&lang=ts&"
import style0 from "./ExternalConsultantsEditor.vue?vue&type=style&index=0&id=052ffbe6&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "052ffbe6",
  null
  
)

export default component.exports